/**
 * Merge History Tab for Incident Editor Dialog (PROJ-047-G)
 *
 * Displays merge history and timeline for an incident.
 */

import { MergeTimelineCard } from '@/components/merge-history/MergeTimelineCard';
import { MergeTimeline } from '@/components/merge-history/MergeTimeline';
import { useNavigate } from 'react-router-dom';

interface MergeHistoryTabProps {
  incidentId: string | null;
}

export function MergeHistoryTab({ incidentId }: MergeHistoryTabProps) {
  const navigate = useNavigate();

  if (!incidentId) {
    return (
      <div className="flex items-center justify-center py-12 text-muted-foreground">
        <p>El historial de fusiones solo está disponible para incidentes guardados</p>
      </div>
    );
  }

  const handleViewTransaction = (transactionId: string) => {
    navigate(`/admin/merge-history/${transactionId}`);
  };

  return (
    <div className="space-y-4">
      <MergeTimeline
        entityId={incidentId}
        entityType="incident"
        onViewTransaction={handleViewTransaction}
      />
    </div>
  );
}
